import { styled } from '@mui/material/styles';

const Card = styled('div')({
    background: '#edf4f7',
    borderRadius: '8px',
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
    marginTop: '0',
    listStyleType: 'none',
    justifyContent: 'center', /* Centers horizontally */
    alignItems: 'center',     /* Centers vertically */
});

export default Card;